// removed by extract-text-webpack-plugin
module.exports = {"flexContent":"_29fnM-C-X-SvJA3GMODn71 undefined"};